const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.405,
    height: 195.605,
    viewBox: "0 0 47.732 51.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Orbitron",
      InkscapeFontSpecification: "Orbitron",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "none",
      fillOpacity: 1,
      stroke: "#a6b9cb",
      strokeWidth: 7.80472469,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.572 418.811v48.8H157.106v-38.667l85.333-99.2h-82.667v-48.8h164.534v38.667l-85.334 99.2z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "266.66665649px",
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat Heavy'",
      fill: "none",
      fillOpacity: 1,
      stroke: "#a6b9cb",
      strokeWidth: 7.80472469,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.26458 0 0 .26458 -40.385 -73.15)",
    "aria-label": "Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZEmpty);
export default __webpack_public_path__ + "static/media/z_empty.de6aa7cec76a6d15f82f35c4427f35a1.svg";
export { ForwardRef as ReactComponent };